export type TVariant =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'error';

export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';

export const OUTLINED = 'outlined';
export const SMALL = 'small';
export const CONTAINED = 'contained';

export const WHATSAPP_COLOR = '#48c357';
export const WHATSAPP_HOVER_COLOR = '#278a41';

export const FACEBOOK_COLOR = '#4064ad';
